module.exports = __webpack_public_path__ + "static/media/PatientReports.83e3d6cb.png";